import { render, staticRenderFns } from "./addPerizinan.vue?vue&type=template&id=232111a8&scoped=true&"
import script from "./addPerizinan.vue?vue&type=script&lang=js&"
export * from "./addPerizinan.vue?vue&type=script&lang=js&"
import style0 from "./addPerizinan.vue?vue&type=style&index=0&id=232111a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232111a8",
  null
  
)

export default component.exports